export const firebaseConfig = {
  apiKey: "AIzaSyBPuamoVk5s_9adqVSRmRVsBA9WWi7nlrs",
  authDomain: "waves-near-me.firebaseapp.com",
  databaseURL: "https://waves-near-me.firebaseio.com",
  projectId: "waves-near-me",
  storageBucket: "waves-near-me.appspot.com",
  messagingSenderId: "121284945874",
  appId: "1:121284945874:web:287afbfd5c6968ccc74a0b",
  measurementId: "G-7L1QTL3KEH",
};
